import { render, staticRenderFns } from "./binario.vue?vue&type=template&id=efb867ba"
import script from "./binario.vue?vue&type=script&lang=js"
export * from "./binario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports